import { useState } from 'react';
import Button from '@components/common/Button';
import { SOCIAL_LINKS } from '@lib/constants';

const CTASection = () => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(SOCIAL_LINKS.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section
      className="py-12 sm:py-16 md:py-20 px-4 border-t"
      style={{
        backgroundColor: 'var(--color-theme-2)',
        borderColor: 'var(--color-border-light)'
      }}
    >
      <div className="container mx-auto text-center max-w-4xl">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4 tracking-tight"
          style={{ color: 'var(--color-heading)' }}
        >
          Let's Connect
        </h2>
        <p
          className="text-sm sm:text-base md:text-lg mb-6 sm:mb-8 leading-relaxed px-2"
          style={{ color: 'var(--color-subtle)' }}
        >
          Interested in collaborating, mentoring, or learning more about my work? I'd love to hear from you.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <button
            onClick={() => setShowEmailModal(true)}
            className="w-full sm:w-auto inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 px-6 py-3 text-lg shadow-card hover:shadow-card-hover"
            style={{
              backgroundColor: 'var(--color-button-primary-bg)',
              color: 'var(--color-button-primary-text)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-button-primary-hover)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-button-primary-bg)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Email Me
          </button>
          <a
            href={`tel:${SOCIAL_LINKS.phone}`}
            className="w-full sm:w-auto inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 px-6 py-3 text-lg hover:shadow-card"
            style={{
              borderColor: 'var(--color-button-outline-border)',
              color: 'var(--color-button-outline-text)',
              borderWidth: '1.5px',
              borderStyle: 'solid',
              backgroundColor: 'transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-button-outline-hover-bg)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Call Me
          </a>
          <a
            href={SOCIAL_LINKS.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 px-6 py-3 text-lg hover:shadow-card"
            style={{
              borderColor: 'var(--color-button-outline-border)',
              color: 'var(--color-button-outline-text)',
              borderWidth: '1.5px',
              borderStyle: 'solid',
              backgroundColor: 'transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-button-outline-hover-bg)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            LinkedIn Profile
          </a>
          <a
            href={SOCIAL_LINKS.github}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 px-6 py-3 text-lg hover:shadow-card"
            style={{
              borderColor: 'var(--color-button-outline-border)',
              color: 'var(--color-button-outline-text)',
              borderWidth: '1.5px',
              borderStyle: 'solid',
              backgroundColor: 'transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-button-outline-hover-bg)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            GitHub Profile
          </a>
        </div>
      </div>

      {/* Email Modal */}
      {showEmailModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
          onClick={() => setShowEmailModal(false)}
        >
          <div
            className="rounded-lg shadow-2xl p-6 max-w-md w-full"
            style={{
              backgroundColor: 'var(--color-card-bg)',
              borderColor: 'var(--color-card-border)',
              borderWidth: '1px'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              className="text-xl font-heading font-bold mb-4"
              style={{ color: 'var(--color-heading)' }}
            >
              Email Address
            </h3>
            <div
              className="p-4 rounded-lg mb-4 font-mono text-center"
              style={{
                backgroundColor: 'var(--color-theme-3)',
                color: 'var(--color-body-text)'
              }}
            >
              {SOCIAL_LINKS.email}
            </div>
            <div className="flex gap-3">
              <button
                onClick={handleCopyEmail}
                className="flex-1 px-4 py-2 rounded-lg font-medium transition-all duration-200"
                style={{
                  backgroundColor: copied ? 'var(--color-accent-6)' : 'var(--color-button-primary-bg)',
                  color: 'var(--color-button-primary-text)'
                }}
              >
                {copied ? '✓ Copied!' : 'Copy Email'}
              </button>
              <button
                onClick={() => setShowEmailModal(false)}
                className="flex-1 px-4 py-2 rounded-lg font-medium transition-all duration-200"
                style={{
                  borderColor: 'var(--color-button-outline-border)',
                  color: 'var(--color-button-outline-text)',
                  borderWidth: '1.5px',
                  borderStyle: 'solid',
                  backgroundColor: 'transparent'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CTASection;
